import React from 'react'
import PropTypes from 'prop-types'

const PriceWrapper = ({ children, ariaLabel }) => {
  return (
    <div className='card-price-points col-12 txt-left color-ui-1 txt-body-lg txt-font-body mt-1' aria-label={ariaLabel}>
      { children }
    </div>
  )
}

PriceWrapper.propTypes = {
  children: PropTypes.elementType,
  ariaLabel: PropTypes.string
}

export default PriceWrapper



// WEBPACK FOOTER //
// ./src/Catalog/Availability/PriceLabel/PriceWrapper.js